module.exports = __webpack_public_path__ + "assets/img/title-7749d2de.png";